var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonNegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#5D38F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6567,
    y: 26.3438,
    width: 1,
    height: 17,
    transform: "rotate(-45 25.6567 26.3438)",
    fill: "#5D38F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3638,
    y: 38.3633,
    width: 1,
    height: 17,
    transform: "rotate(-135 26.3638 38.3633)",
    fill: "#5D38F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNegative);
export default __webpack_public_path__ + "static/media/button-negative.3fdb1da5fa497060267716d4f43180ac.svg";
export { ForwardRef as ReactComponent };